import React from 'react';
import { Hero } from '../components/Hero';
import { DailySpecials } from '../components/DailySpecials';
import { TastingMenu } from '../components/TastingMenu';
import { Gallery } from '../components/Gallery';
import { PrivateDining } from '../components/PrivateDining';
import { MapHours } from '../components/MapHours';
import { Footer } from '../components/Footer';
import { ReservationWidget } from '../components/ReservationWidget';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-slate-900" data-id="element-143">
      <Hero data-id="element-144" />
      <DailySpecials data-id="element-145" />
      <TastingMenu data-id="element-146" />
      <Gallery data-id="element-147" />
      <PrivateDining data-id="element-148" />
      <MapHours data-id="element-149" />
      <Footer data-id="element-150" />
      <ReservationWidget data-id="element-151" />
    </div>;
}